<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="organiza-txt add-list"  v-if="addType">
        <div class="organiza-title clear">
          <div class="organiza-left" @click="backSub">
            <p>返回</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>词库包：</p>
              <el-select v-model="addObj.library_id" placeholder="请选择">
                <el-option
                  v-for="item in LibraryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-item" v-if="listType==3">
              <p>等级：</p>
              <el-select v-model="addObj.level" placeholder="请选择">
                <el-option
                  v-for="item in 9"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <p class="global-search">
                <el-checkbox @change="wordAll" v-model="allChecked">全选当前搜索</el-checkbox>
              </p>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="wordSearch">搜索</button>
              <button class="btn btn-reset" @click="wordReset">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in addTitle" v-bind:key="item.id">{{item.title}}</p>
            <p>
              <el-checkbox v-model="allWord" @change="wordChange">全选</el-checkbox>
            </p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in addList" v-bind:key="(index+1)">
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.content">{{item.content}}</p> 
              <p>
                <el-checkbox @change="wordChoose(item)" v-model="item.type"></el-checkbox>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleWordChange"
              :current-page.sync="addObj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="WordtotalPage">
            </el-pagination> 
          </div>

          <div class="btn btnBox">
            <button class="btn btn-sub" @click="saveSub">确定</button>
            <button class="btn btn-close" @click="backSub">关闭</button>
          </div>
        </div>
      </div>

      <div class="MobelBox" v-if="stepType" style="height:calc( 100% - 100px )">
        <div class="backBox">
          <button class="btn btn-back" @click="closeSub">返回</button>
        </div>

        <div class="write-txt">
          <p class="write-title">模块名称：<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="" v-model="stepObj.name"></textarea>
          </div>
        </div>
        

        <div class="write-btnBox">
          <button class="btn btn-save" @click="stepSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加</p>
          </div>
          <div class="searchBox clear">
            
            <div class="search-item name">
              <p>现代文阅读：</p>
              <input type="text" placeholder="请输入要搜索的名称" v-model="obj.name">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>

            
          </div>
        </div>
        <p class="list-title">模块列表</p>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.motif_count">{{item.motif_count}}</p> 
              <p :title="item.exercises_count">{{item.exercises_count}}</p> 
              <p :title="item.sort">{{item.sort}}</p> 
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="删除" style="color: #FF1919;" class="btn btn-remove" @click="removeShow(item)">删除</button>
                <button style="color: #01CD81;" title="母题" class="btn btn-revise" @click="examSub(item,'1')">母题</button>
                <button style="color: #01CD81;" title="习题" class="btn btn-revise" @click="examSub(item,'2')">习题</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="removeHide">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPackageSubList,savePackageSubRead,getLibraryAllList ,getPackageSubNotJoinedList,delPackageSubRead ,updatePackageStatus,addWordSub ,getPackageSubReadList} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'3',
      titleList:[],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10,
        lid:'',
        step:''
      },
      totalPage:0,
      removeID:'',
      url:'',
      listType:'',
      addTitle:[],
      addList:[],
      LibraryList:[],
      addWOrdObj:{
        lid:'',
        type:0,
        sids:[]
      },
      addObj:{
        lid:'',
        page:1,
        rows:10,
      },
      allChecked:false,
      allWord:false,
      WordtotalPage:0,
      thisLevel:0,
      stepList: [
        { id: 1, title: "考点定位" },
        { id: 2, title: "标答拆解" },
        { id: 3, title: "步骤逆推" },
        { id: 4, title: "反向解题" },
      ],
      stepType:false,
      stepObj:{
        lid:'',
        step:'',
        name:''
      }
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.obj.lid = this.addObj.lid = this.addWOrdObj.lid = this.stepObj.lid = this.$route.query.lid;
    this.obj.step = this.stepObj.step = this.$route.query.step;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    handleWordChange(val) {
      console.log(`当前页: ${val}`);
      this.addSub();
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    wordSearch(){
      this.addObj.page = 1;
      this.addList = [];
      this.addSub();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
        lid:this.$route.query.lid,
      };
      this.dataList = [];
      this.getList();
    },

    wordReset(){
      this.addWOrdObj.type=0;
      this.addWOrdObj.sids=[];
      this.addObj = {
        lid:this.$route.query.lid,
        page:1,
        rows:10,
      }
      this.addList = [];
      this.addSub();
    },

    backSub(){
      this.addWOrdObj={
        lid:this.$route.query.lid,
        type:0,
        sids:[]
      };
      this.addObj={
        lid:this.$route.query.lid,
        page:1,
        rows:10,
      };
      this.allChecked=false;
      this.allWord=false;
      this.addList = [];
      this.WordtotalPage=0;
      this.addWOrdObj.type=0;
      this.addWOrdObj.sids=[];
      this.addList = [];
      this.addType = '';
    },

    async getList(){
      var that = this;
      try {
        const response = await getPackageSubReadList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;  
          that.listType = response.data.type;
            that.titleList = [
              {id:1,title:'序号'},
              {id:2,title:'模块'},
              {id:3,title:'母题数量'},
              {id:4,title:'习题数量'},
              {id:5,title:'排序'},
              {id:6,title:'操作'},
            ]
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async addSub(){
      var that = this;
      this.stepType = true;
      // try {
      //   const response = await getPackageSubNotJoinedList(this.addObj,this.token);
      //   if(response.code == 200){
      //     that.addType = 'add';
      //     if(that.listType == 1){
      //       that.addTitle = [
      //         {id:1,title:'实词/虚词'},
      //         {id:2,title:'词义'},
      //       ];
      //       that.thisLevel = response.data.this_level;
      //     } else if(that.listType == 2){
      //       that.addTitle = [
      //         {id:1,title:'古诗名'},
      //         {id:2,title:'作者'},
      //       ]
      //     }  else if(that.listType == 3){
      //       that.addTitle = [
      //         {id:1,title:'单词'},
      //         {id:2,title:'中文'},
      //       ]
      //     };
      //     that.getLibraryAll();
      //     response.data.list.forEach(function(item,index){
      //       item.type = false;
      //     })
      //     that.addList = response.data.list;
      //     that.WordtotalPage = response.data.total_page;
      //   } else {
      //     that.$message(response.msg);
      //   }
      // } catch (error) {
      //   that.$message(error);
      // }

    },


    async stepSub(){
      var that = this;
      try {
        const response = await savePackageSubRead(this.stepObj,this.token);
        if(response.code == 200){
          that.$message('成功！');
          that.closeSub();
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async getLibraryAll(){
      var that = this;
      try {
        const response = await getLibraryAllList({type:this.listType},this.token);
        if(response.code == 200){
          that.LibraryList = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    buildSub(e){
      this.stepType = true;
      this.stepObj.name = e.name;
      this.stepObj.model_id = e.model_id;
    },

    removeShow(e){
      console.log(e)
      this.removeID = e.model_id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delPackageSubRead({model_id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.removeID = '';
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeHide(){
      var that = this;
      that.removeType = false;
      that.removeID = '';
    },

    async saveSub(){
      var that = this;
      // if(this.addObj.lid == ''){
      //   that.$message('请选择资源库！');
      //   return false;
      // }
      // if(this.addObj.title == ''){
      //   that.$message('请输入资源包名称！');
      //   return false;
      // }
      // if(this.addObj.vip_time == ''){
      //   that.$message('请输入有效期！');
      //   return false;
      // }
      // if(this.addObj.price == ''){
      //   that.$message('请填写价格！');
      //   return false;
      // }
      // if(this.addObj.sort == ''){
      //   that.$message('请填写排序！');
      //   return false;
      // }
      // this.addObj.vip_time = this.addObj.vip_time + this.vip_date;
      // if(this.addObj.type == 1){
      //   if(!this.addObj.bind_id){
      //     this.addObj.bind_id = -1
      //   }
      // };
      if(this.addObj.library_id){
        this.addWOrdObj.library_id = this.addObj.library_id;
      }
      console.log(this.addWOrdObj);
      try {
        const response = await addWordSub(this.addWOrdObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          window.location.reload();      
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addHide(){
      // this.addWOrdObj={
      //   lid:this.$route.query.lid,
      //   type:0,
      //   sids:[]
      // };
      // this.addObj={
      //   lid:this.$route.query.lid,
      //   page:1,
      //   rows:10,
      // };
      // this.allChecked=false;
      // this.allWord=false;
      // this.addList = [];
      // this.WordtotalPage=0;
      // this.addType = '';
      window.location.reload();
    },

    async switchChange(e){
      var that = this;
      var obj = {
        lid:e.lid,
        status:e.status==false?0:1,
      };
      try {
        const response = await updatePackageStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        page:1,
        rows:10,

      };
      this.vip_date = 'd';
      this.stepType = false;
      this.stepObj = {
        name:''
      };
      this.addObj.lid = this.stepObj.lid = this.$route.query.lid;
      this.stepObj.step = this.$route.query.step;
    },

    wordChange(){
      var that = this;
      if(this.allWord){
        this.addList.forEach(function(item,index){
          item.type = true;
          if(that.listType==1){
            that.addWOrdObj.sids.push(item.sense_id)
          } else {
            that.addWOrdObj.sids.push(item.sid)
          }
        })
      } else {
        this.addList.forEach(function(item,index){
          item.type = false;
        });
        that.addWOrdObj.sids = [];
      }
    },

    wordAll(e){
      if(this.allChecked){
        this.addWOrdObj.type = 1;
        if(this.addObj.library_id){
          this.addWOrdObj.library_id = this.addObj.library_id;
        }
        if(this.listType == 3){
          this.addWOrdObj.level = this.addObj.level;
        }
        delete this.addWOrdObj.sids;
        this.addList.forEach(function(item,index){
          item.type = true;
        })
      } else {
        this.addWOrdObj.type = 0;
        this.addWOrdObj.sids = [];
        delete this.addWOrdObj.library_id;
        delete this.addWOrdObj.level;
        this.addList.forEach(function(item,index){
          item.type = true;
        })
      }
    },

    wordChoose(e){
      var that = this;
      if(e.type){
        if(this.listType == 1){
          that.addWOrdObj.sids.push(e.sense_id);
          try {
            that.addList.forEach(function(item,index){
              if(e.sid == item.sid && item.level < that.thisLevel && item.level > 0){
                item.type = true;
                if(that.addWOrdObj.sids.indexOf(item.sense_id) == -1){
                  that.addWOrdObj.sids.push(item.sense_id);
                }
              } 
            });
          } catch(e) {
            if (e.message != "EndIterative") {
                throw e;
            } else {
                return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
            }
          };
        } else {
          this.addWOrdObj.sids.push(e.sid);
        }
      } else {
        if(this.listType == 1){
          if(this.addWOrdObj.sids.indexOf(e.sense_id) > -1){
            var index = this.addWOrdObj.sids.indexOf(e.sense_id);
            this.addWOrdObj.sids.splice(index,1)
          }
        } else {
          if(this.addWOrdObj.sids.indexOf(e.sid) > -1){
            var index = this.addWOrdObj.sids.indexOf(e.sid);
            this.addWOrdObj.sids.splice(index,1)
          }
        }
      };

    },

    examSub(e,type){
      this.$router.push('/readExam?read_type='+type+'&model_id='+e.model_id+'&lid='+this.$route.query.lid);
    }

  }

  
};
</script>
<style scoped>
  .search-item.name input{
    width: 240px;
  }

  .search-item>>> input{
    width: 147px;
    border: solid 1px #333333;
  }

  .el-select-dropdown__item.selected{
    color: #333333;
  }

  .el-select-dropdown__item.hover{
    background-color: #00C7A3;
    color: #fff;
  }

  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .dataList .listItem p.btnList{
    font-size: 0;
    white-space: break-spaces;
  }

  
  .add-list .dataList .listItem p, 
  .add-list .organiza-list p{
    width: calc( 100% / 3 );
  }

  .btnList .btn{
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #333333;
    margin: 0 10px 7px 0;
    text-align: left;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.reviewBox .write-text input,
.write-txt>>> .el-radio-group{
  display: inline-block;
  vertical-align: middle;
}

.content>>> .el-radio__input.is-checked .el-radio__inner{
  background-color: #00C7A3;
  border-color: #00C7A3;
}

.content>>> .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #00C7A3;
}

.content>>> .el-radio__input.is-checked+.el-radio__label{
  color: #00C7A3;
}

.reviewBox .write-text input{
  margin-right: 20px;
}

.reviewBox .btn-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  padding: 6px 24px;
  box-sizing: border-box;
  display: block;
  margin-top: 37px;
  border: solid 1px #00C7A3;
}


.MobelBox .write-text .btn.btn-review-remove{
  color: #fff;
  font-size: 18px;
  background-color: #F26060;
  border-radius: 6px;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 36px;
  display: inline-block;
  vertical-align: top;
  margin-left: 30px;
}

.add-list>>> .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #333333;
}

.add-list>>> .el-checkbox__inner:hover{
  border-color: #00C7A3;
}

.add-list>>> .el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: #00C7A3;
  border-color: #00C7A3;
}

.global-search{
  float: none;
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
}

.add-list .dataList{
  height: calc( 100% - 260px );
}

.add-list .btnBox{
  display: block;
  margin-top: 50px;
  text-align: center;
}

.add-list .btnBox .btn{
  display: inline-block;
  vertical-align: top;
  width: 145px;
  height: 51px;
  line-height: 51px;
  background-color: #00C7A3;
  border-radius: 8px;
  color: #fff;
  font-size: 20px;
}

.add-list .btnBox .btn.btn-close{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pack/read.vue